if (!customElements.get('art-print-offer')) {
  class ArtPrintOffer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('on:cart:add', this.handleCartAdd.bind(this));
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleCartAdd(event) {
      if (event.detail.variantId.toString() !== this.dataset.variantId) return;

      const modal = this.querySelector('modal-dialog');
      if (!modal) return;

      // ProductForm opens the cart drawer after its add animation; close once it is visible.
      window.setTimeout(() => modal.close(), 800);
    }

    async handleClick(event) {
      const button = event.target.closest('[data-art-print-bundle]');
      if (!button || button.getAttribute('aria-disabled') === 'true') return;

      const form = this.querySelector('.js-product-form');
      const errorMessage = this.querySelector('[data-bundle-error]');
      const status = this.querySelector('[data-bundle-status]');
      const originalLabel = button.textContent;
      const properties = {};

      form.querySelectorAll('[name^="properties["]').forEach((input) => {
        properties[input.name.slice(11, -1)] = input.value;
      });

      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding both…';
      errorMessage.hidden = true;

      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [
              { id: Number(button.dataset.artPrintVariantId), quantity: 1, properties },
              { id: Number(button.dataset.goldKitVariantId), quantity: 1 }
            ]
          })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || response.status);

        button.textContent = 'Added both ✓';
        status.textContent = 'Art Print and Gold Leafing Kit added to your cart.';

        const modal = this.querySelector('modal-dialog');
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.refreshCartDrawer === 'function') {
          await cartDrawer.refreshCartDrawer(false);
          window.setTimeout(() => {
            if (typeof cartDrawer.open === 'function') cartDrawer.open();
            window.setTimeout(() => modal.close(), 500);
          }, 300);
        } else {
          window.location.href = theme.routes.cart;
        }
      } catch (error) {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-busy');
        button.textContent = originalLabel;
        errorMessage.textContent = 'We couldn’t add the Art Print and Gold Leafing Kit. Please try again.';
        errorMessage.hidden = false;
      }
    }
  }

  customElements.define('art-print-offer', ArtPrintOffer);
}
